<template>
  <div class="editor">
    <editor-menu-bar :editor="editor">
      <div
        class="menubar is-hidden ux-text-editor"
        :class="{ 'is-focused': focused }"
        slot-scope="{ commands, isActive, focused }"
      >
        <button class :class="{ 'is-active': isActive.paragraph() }" @click="commands.paragraph">P</button>

        <button
          :class="{ 'is-active': isActive.heading({ level: 1 }) }"
          @click="commands.heading({ level: 1 })"
        >H1</button>

        <button
          v-if="false"
          :class="{ 'is-active': isActive.heading({ level: 2 }) }"
          @click="commands.heading({ level: 2 })"
        >H2</button>

        <button
          v-if="false"
          :class="{ 'is-active': isActive.heading({ level: 3 }) }"
          @click="commands.heading({ level: 3 })"
        >H3</button>

        <button
          class
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <i class="material-icons">format_list_bulleted</i>
        </button>

        <button
          class
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list"
        >
          <i class="material-icons">format_list_numbered</i>
        </button>

        <button class="bold" :class="{ 'is-active': isActive.bold() }" @click="commands.bold">B</button>

        <button
          class="italic"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >I</button>
        <button
          class="underline"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <span>U</span>
        </button>

        <button
          class="image"
          :class="{ 'is-active': isActive.underline() }"
          @click="pickImage(commands.image)"
        >
          <i class="material-icons">image</i>
        </button>

        <button
          v-if="false"
          class
          :class="{ 'is-active': isActive.strike() }"
          @click="commands.strike"
        >
          <i class="material-icons">format_strikethrough</i>
        </button>

        <button v-if="false" :class="{ 'is-active': isActive.code() }" @click="commands.code">
          <i class="material-icons">code</i>
        </button>

        <button
          v-if="false"
          class
          :class="{ 'is-active': isActive.blockquote() }"
          @click="commands.blockquote"
        >
          <i class="material-icons">format_quote</i>
        </button>

        <button
          v-if="false"
          class
          :class="{ 'is-active': isActive.code_block() }"
          @click="commands.code_block"
        >
          <i class="material-icons">code</i>
        </button>
      </div>
    </editor-menu-bar>

    <editor-content class="editor__content" :editor="editor"/>

    <ux-modal-dialog :show="show" @close="cancel">
      <ux-image-picker :items="uploads" keyTitle="name" @select="updateImage"></ux-image-picker>
    </ux-modal-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import UxModalDialog from "./UxModalDialog";
import UxImagePicker from "./UxImagePicker";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  Blockquote,
  BulletList,
  CodeBlock,
  HardBreak,
  Heading,
  ListItem,
  OrderedList,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Image,
  Link,
  Strike,
  Underline,
  History
} from "tiptap-extensions";

export default {
  components: {
    EditorContent,
    EditorMenuBar,
    UxModalDialog,
    UxImagePicker
  },
  data() {
    return {
      blurb: "whakamole",
      src: null,
      command: null,
      show: false,
      editor: null
    };
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  created() {
    this.$store.dispatch("setAboutText");
  },
  mounted() {
    let that = this;
    this.editor = new Editor({
      onUpdate: _.debounce(data => {
        this.updateText(data.getHTML());
      }, 500),
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Bold(),
        new Code(),
        new Italic(),
        new Link(),
        new Strike(),
        new Underline(),
        new History(),
        new Image()
      ]
    });
    this.initialText();
  },
  methods: {
    initialText() {
      let content = this.$store.getters.aboutText;
      if (content) {
        this.editor.setContent(content);
      }
    },
    showImagePrompt(command) {
      const src = prompt("Enter the url of your image here");
      if (src !== null) {
        command({ src });
      }
    },
    pickImage(command) {
      // Do stuff here
      this.src = null;
      this.show = true;
      this.command = command;
    },
    updateImage(img) {
      this.command({ src: img });
      this.show = false;
      this.command = null;
    },
    cancel() {
      if (!this.$store.getters.isLoggedIn) {
        this.show = false;
        return;
      }
      this.show = !this.show;
    },
    updateText(data) {
      this.$emit("textupdate", data);
    }
  },
  computed: {
    uploads() {
      return this.$store.getters.uploads;
    },
    initContent() {
      return this.$store.getters.aboutText;
    }
  }
};
</script>
<style lang="scss" scoped>
.menubar {
  transition: visibility 0.2s 0.4s, opacity 0.2s 0.4s;
}
.menubar.is-hidden {
  /* visibility: hidden; */
  /* opacity: 0; */
}
.menubar.is-focused {
  visibility: visible;
  opacity: 1;
  transition: visibility 0.2s, opacity 0.2s;
}

.ux-text-editor {
  display: flex;
  margin: 1rem auto;
  border-top: 1px solid #444;
  padding-top: 5px;
  border-bottom: 1px solid #444;
  padding-bottom: 5px;
  button {
    justify-content: center;
    background: #333;
    min-width: 30px;
    margin: 0 3px;
    flex: 1;
    color: rgb(177, 177, 177);
    &.underline {
      span {
        border-bottom: 2px solid;
      }
    }
    &.italic {
      font-style: italic;
    }
    &.bold {
      font-weight: bolder;
    }
    i.material-icons {
      margin-right: 0;
    }
    &.is-active {
      background: #555;
      color: white;
    }
  }
}
div.editor__content {
  font-size: 16px;
}
</style>
